import '@/assets/scss/main.scss';
import Vue from 'vue';
import '../node_modules/vuetify/dist/vuetify.min.css';
import App from './App';
import router from './router';
import components from './components';
import directives from './directives';
import filters from './filters';
import plugins from './plugins';
import services from './services';
import store from './store';
import i18n from './i18n';

Vue.config.productionTip = false;

Vue.use(components);
Vue.use(directives);
Vue.use(filters);
Vue.use(plugins);
Vue.use(services);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  store,
  router,
  render: h => h(App),
});



// WEBPACK FOOTER //
// ./src/main.js